// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ueCA","content":"styles_content__2HrbK","tableWrap":"styles_tableWrap__1UU5J"};